// Module
var code = "<tr> <td><%- label %></td> <td class=text-right><%= amount %></td> </tr> ";
// Exports
module.exports = code;